import { formatCurrency } from 'utils/utils';

export const transformEntityToCard = (entity) => {
	const targetSize = Number(entity.target_size) || 0;
	const totalCommitments = Number(entity.total_commitments) || 0;
	const progressPercent =
		targetSize > 0 ? (totalCommitments / targetSize) * 100 : 0;
	const isAtOrOverTarget = targetSize > 0 && totalCommitments >= targetSize;

	return {
		id: entity.id,
		name: entity.name || 'Unnamed Entity',
		entityType: entity.entity_type || 'Unknown Type',
		status: entity.status || 'Unknown',
		stats: [
			{
				label: 'Target Size',
				value:
					targetSize > 0
						? formatCurrency(targetSize, 'USD', { compact: true, decimalPlaces: 1 })
						: 'N/A',
			},
			{
				label: 'Total Commitments',
				value:
					totalCommitments > 0
						? formatCurrency(totalCommitments, 'USD', { compact: true, decimalPlaces: 1 })
						: '$0',
				valueColor: isAtOrOverTarget ? 'success' : 'primary',
			},
		],
		bar:
			targetSize > 0
				? {
						percent: Math.min(progressPercent, 100),
						color: isAtOrOverTarget ? 'success' : 'primary',
					}
				: null,
		footer: 'Click to enter fundraise dashboard',
		footerHighlight: true,
		activeRaise: false,
	};
};
